import { create } from "zustand";
import { initSocket, disconnectSocket } from "../services/socket";
import useDashboardStore from "./dashboardStore";
import chatStore from "./chatStore";

const useAuthStore = create((set) => ({
  user: JSON.parse(localStorage.getItem("user")) || null,
  userMeta: JSON.parse(localStorage.getItem("userMeta")) || null,
  isAuthenticated: localStorage.getItem("user"),
  socket: null,

  setSocket: (socketInstance) => set({ socket: socketInstance }),
  setUserMeta: (userMeta) => {
    localStorage.setItem("userMeta", JSON.stringify(userMeta));
    set({ userMeta });
  },

  login: (accessToken, user, userMeta) => {
    // Save tokens
    localStorage.setItem("accessToken", accessToken);

    // Save user info
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("userMeta", JSON.stringify(userMeta));
    const socket = initSocket(userMeta.session_id);
    set({ user, userMeta, isAuthenticated: true, socket });
    // useDashboardStore.getState().setIsUS30Choosed();
  },

  logout: () => {
    // Remove user info
    localStorage.removeItem("user");
    localStorage.removeItem("userMeta");

    // Remove the last-screen
    localStorage.removeItem("lastScreen");

    // Remove tokens
    localStorage.removeItem("accessToken");

    // Disconnect sockets
    disconnectSocket();

    // Reset other stores
    useDashboardStore.getState().resetDashboard();
    chatStore.getState().resetChat();
    set({ user: null, userMeta: null, isAuthenticated: false, socket: null });
  },

  updateMembershipDetails: (
    oldUserMeta,
    is_membership_active,
    membership_ids
  ) => {
    const newUserMeta = {
      ...oldUserMeta,
      is_membership_active,
      membership_ids,
    };
    localStorage.setItem("userMeta", JSON.stringify(newUserMeta));
    set({ userMeta: newUserMeta });
  },
}));

export default useAuthStore;
